import { Button } from "@dash/form";
import { useDeviceType } from "@dash/mq";
import { SelectDialog } from "@dash/select";
import { MdOutlineCalendarMonth } from "react-icons/md";
import { useNavigate } from "react-router-dom-v5-compat";

import { useClientManager } from "@megaron/react-clients";
import { getMegaraxPath } from "@megaron/megarax-uri";

export const CalendarButton = () => {
  const navigate = useNavigate();

  const profilesQuery = useClientManager("auth").userProfilesQuery().useQuery({});

  const profilesOptions =
    profilesQuery.data?.items.map((profile) => ({
      label: profile.firstName && profile.lastName ? `${profile.firstName} ${profile.lastName}` : profile.email,
      value: profile.legacyUserId.toString(),
    })) || [];

  const { isMobile } = useDeviceType();

  return (
    <SelectDialog
      label={"Handlowiec"}
      options={profilesOptions}
      onSelect={(option) => {
        navigate(
          getMegaraxPath.uri("megarax://crm/salesperson-visits/id/{id}/{view}", {
            id: String(option?.value),
            view: "week",
          }),
        );
      }}
      variant="single-select"
      renderTrigger={(_, __, ___, onOpen) => (
        <Button icon={<MdOutlineCalendarMonth />} variant="outline" size="small" onClick={onOpen}>
          {!isMobile && "Kalendarz"}
        </Button>
      )}
    />
  );
};
